export default __webpack_public_path__ + "images/Mavia_b66d0b2.jpg";